import { Moment } from 'moment';

export enum OsXFinancialReportType {
  noFinancialOrDivergentValue,
  overview,
}
export enum OsXFinancialFilterDateBy {
  delivery,
  authorization,
  closure,
  os,
  financial,
}

export enum OsXFinancialCompareValueBy {
  grossValue,
  netValue,
}

export enum OsXFinancialFilterOsBy {
  delivery,
  authorization,
  closure,
  emission,
  dueDate,
  receipt,
}

export interface QuestReportOsXFinancialRequest {
  reportType: OsXFinancialReportType;
  companiesIds?: string;
  employeesId?: string;
  documentTypesIds?: string;
  filterDateBy: OsXFinancialFilterDateBy;
  compareValueBy?: OsXFinancialCompareValueBy;
  filterOsBy?: OsXFinancialFilterOsBy;
  onlyOsWithoutFinancialRecord?: boolean;
  startDate: string;
  endDate: string;
}

export interface QuestReportOsXFinancialFormValues {
  reportType: OsXFinancialReportType;
  companiesIds?: number[];
  employeesId?: number;
  documentTypesIds?: number[];
  filterDateBy: OsXFinancialFilterDateBy;
  compareValueBy?: OsXFinancialCompareValueBy;
  filterOsBy?: OsXFinancialFilterOsBy;
  onlyOsWithoutFinancialRecord?: boolean;
  initialDate: Moment;
  finalDate: Moment;
}
